export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "defaultOptionText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["--選択してください--"])}
    }
  })
}
